import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-home\"><path d=\"M843.008 248.576l-222.293333-140.586667a203.605333 203.605333 0 0 0-216.576 0l-222.293334 140.586667A201.557333 201.557333 0 0 0 87.466667 419.84v337.237333a180.224 180.224 0 0 0 180.010666 179.882667h489.898667a180.224 180.224 0 0 0 180.010667-180.053333v-337.066667a201.557333 201.557333 0 0 0-94.378667-171.264z m-177.749333 553.258667a35.84 35.84 0 0 1-71.68 0v-171.477334a81.152 81.152 0 1 0-162.304 0v171.52a35.84 35.84 0 0 1-71.68 0v-171.52a152.917333 152.917333 0 0 1 152.832-152.832 152.917333 152.917333 0 0 1 152.832 152.832v171.52z\" p-id=\"2233\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 27